import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';

export const gridviewService = {
  get,
  dataget,
  add,
  defaultedit,
  del
};

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  controller: 'gridview'
};

function extract(r) {
  return r.data;
}

async function get(pGridViewModuleTypeId) {
  return axios.get(`${model.baseUrl}${model.controller}/get?pGridViewModuleTypeId=${pGridViewModuleTypeId}`).then(extract);
}
async function dataget(pDataTypeId, pGridViewModuleTypeId, pGridViewId) {
  return axios.get(`${model.baseUrl}${model.controller}/dataget?pDataTypeId=${pDataTypeId}${pGridViewModuleTypeId ? '&pGridViewModuleTypeId=' + pGridViewModuleTypeId : ''}${pGridViewId ? '&pGridViewId=' + pGridViewId : ''}`).then(extract);
}

async function add(pGridViewTypeId, pGridViewModuleTypeId, pGridViewName, pIsDefault, pGridViewData) {
  return axios.put(`${model.baseUrl}${model.controller}/add`, { pGridViewTypeId, pGridViewModuleTypeId, pGridViewName, pIsDefault, pGridViewData });
}

async function defaultedit(pGridViewId, pIsDefault) {
  return axios.post(`${model.baseUrl}${model.controller}/defaultedit`, { pGridViewId, pIsDefault });
}

async function del(pGridViewId) {
  return axios.delete(`${model.baseUrl}${model.controller}/del`, { data: { pGridViewId } });
}
